import Product from "./Product";

export default class ParentService {
    id: number = 0;
    referenceCode: string = "";
    name: string = "";
    description: string = "";
    services: Product[] = [];

    static fetchParentServiceFromJson(parentService: any): ParentService {
        var parentServiceObject = new ParentService();

        parentServiceObject.id = parentService.id;
        parentServiceObject.referenceCode = parentService.referenceCode;
        parentServiceObject.name = parentService.name;
        parentServiceObject.description = parentService.description;
        parentServiceObject.services = Array.isArray(parentService.services)
            ? parentService.services.map((service: any) => Product.fetchItemObjectFromJson(service))
            : [];

        return parentServiceObject;
    }
}
